
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forums/ForumViewAllTopicsPage/ForumViewAllTopicsPage",
      function () {
        return require("private-next-pages/forums/ForumViewAllTopicsPage/ForumViewAllTopicsPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forums/ForumViewAllTopicsPage/ForumViewAllTopicsPage"])
      });
    }
  